// import { getToken, setToken, removeToken, getIsAdmin, setIsAdmin } from '@/utils/cookie'
import { getToken, setToken, removeToken } from '@/utils/cookie'

import api from '@/api'

const state = {
  isAdmin: false,
  isCalander: false,
  isIntellectual: false,
  menus: JSON.parse(localStorage.getItem('menus')),
  needSync: false,
  token: getToken()
}

const mutations = {
  SET_IS_ADMIN: (state, need) => {
    state.isAdmin = need
  },
  SET_IS_CALANDER: (state, need) => {
    state.isCalander = need
  },
  SET_IS_INTELLECTUAL: (state, need) => {
    state.isIntellectual = need
  },
  SET_NEED_SYNC: (state, need) => {
    state.needSync = need
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  REMOVE_TOKEN: () => {
    removeToken()
    state.token = ''
  },
  SET_MENUS: (state, datas) => {
    localStorage.setItem('menus', JSON.stringify(datas))
    state.menus = datas
  }
}

const actions = {
  login ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.post('ent.employee/login', params, res => {
        const { token } = res.data
        commit('SET_TOKEN', token)
        commit('SET_IS_ADMIN', parseInt(res.data.is_admin) === 1)
        commit('SET_IS_CALANDER', parseInt(res.data.is_calander) === 1)
        commit('SET_IS_INTELLECTUAL', parseInt(res.data.is_intellectual) === 1)
        setToken(token)

        const { menus } = res.data
        commit('SET_MENUS', menus)

        resolve()
      })
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      api.post('ent.employee/logout', null, (res) => {
        setToken(null)
        removeToken()
        resolve()
      })
    })
  },
  needSync ({ commit }, need) {
    commit('SET_NEED_SYNC', need)
  },
  setIsAdmin ({ commit }, need) {
    commit('SET_IS_ADMIN', need)
  },
  setIsCalander ({ commit }, need) {
    commit('SET_IS_CALANDER', need)
  }
}

export default {
  namespaced: true,
  actions,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js